import WidgetConfiguration from "./WidgetConfiguration";

export { WidgetConfiguration };
